/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AuthService } from './services/auth.service';
import { FilesService } from './services/files.service';
import { FoyService } from './services/foy.service';
import { QuestionAnswerService } from './services/question-answer.service';
import { RegistrationService } from './services/registration.service';
import { SurveyService } from './services/survey.service';
import { SurveyInstanceDataService } from './services/survey-instance-data.service';
import { UserService } from './services/user.service';
import { UsersPanelService } from './services/users-panel.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AuthService,
    FilesService,
    FoyService,
    QuestionAnswerService,
    RegistrationService,
    SurveyService,
    SurveyInstanceDataService,
    UserService,
    UsersPanelService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
